<template>
  <div class="home-page">
    <div class="app-entry">
      <img :src="require('@/assets/app.png')" alt="">
      <a href="https://easylink.cc/466548">app下载体验</a>
    </div>
    <div id="ChinaEchart" class="china-chart"></div>
    <a-button type="primary" v-if="now_province!='china'" size="small" @click="back">返回中国</a-button>
  </div>
</template>

<script>

import * as echarts from 'echarts'
import {ChinaEcharts} from "@/views/Echarts/echart_home";
import {Get_Json} from "@/views/Echarts/json";
import {get_home} from "@/api/home";


export default {
  data() {
    return {
      ChinaEchart:null,
      ChinaEchart_data:[],
      ChinaEchart_Option:{},
      now_province:'china'
    }
  },
  methods: {
    get_home(){

    },
    back(){
      this.now_province='china';
      this.init_map();
    },
    async get_map_data() {
      try {
        const res = await get_home(this.now_province);
        console.log('HOME:'+res.code);
        this.ChinaEchart_data = res.cityList;
        console.log(this.ChinaEchart_data);
      } catch (error) {
        console.error('Error fetching map data:', error);
      }
    },
    async init_map(){
      await this.get_map_data();
      console.log(this.ChinaEchart_data);
      this.ChinaEchart_Option = ChinaEcharts(this.ChinaEchart_data);
      if (this.ChinaEchart) {
        this.ChinaEchart.dispose();
      }
      this.ChinaEchart = echarts.init(document.getElementById('ChinaEchart'));
      this.ChinaEchart.showLoading();
      var usaJson = Get_Json(this.now_province);
      this.ChinaEchart.hideLoading();
      echarts.registerMap('CHINA', usaJson, {
        Alaska: {
          left: -131,
          top: 25,
          width: 15
        },
        Hawaii: {
          left: -110,
          top: 28,
          width: 5
        },
        'Puerto Rico': {
          left: -76,
          top: 26,
          width: 2
        }
      });
      this.ChinaEchart.setOption(this.ChinaEchart_Option);
      this.resizeChart();

      var that = this;
      this.ChinaEchart.off("click");
      this.ChinaEchart.on("click", function (params) {
        that.now_province = params.name;
        that.init_map();
      });
    },
    resizeChart() {
      if (this.ChinaEchart) {
        this.ChinaEchart.resize();
      }
    },
    initialize(){
      this.init_map();
      window.addEventListener('resize', this.resizeChart);
    },
    navigateTo(pathName) {
      this.$router.push({ path: pathName });
    },
  },
  mounted() {
    this.initialize();
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeChart);
    if (this.ChinaEchart) {
      this.ChinaEchart.dispose();
    }
  },
};
</script>

<style scoped>
.home-page {
  position: relative;
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 12px;
  width: 100%;
  min-height: calc(100vh - 80px);
  background-color: #fff;
  padding: 12px;
}

.app-entry {
  flex: 0 0 120px;
  text-align: center;
}

.app-entry img {
  width: 100px;
  height: 100px;
  display: block;
  margin: 0 auto 6px;
}

.china-chart {
  flex: 1 1 auto;
  width: 100%;
  max-width: 1000px;
  height: min(78vh, 760px);
  min-height: 420px;
}

@media (max-width: 768px) {
  .home-page {
    flex-direction: column;
    align-items: stretch;
    min-height: auto;
    padding: 8px;
  }

  .app-entry {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 10px;
    flex: none;
  }

  .app-entry img {
    width: 56px;
    height: 56px;
    margin: 0;
  }

  .china-chart {
    max-width: none;
    height: 62vh;
    min-height: 360px;
  }
}
</style>
